/*
 * Furnish My Space request form (snippets/pv-prp-form.liquid).
 * Native validation does the required fields (name, WhatsApp AND email are
 * all required); this adds the rules HTML cannot express:
 *  - at least one piece ticked;
 *  - the Private Home Consultation tick shown only for Dubai, Abu Dhabi and
 *    Sharjah (the first three emirates in the list);
 *  - fix batch 2026-10-03 (A6): a request number (FMS-YYMMDD-XXX) made at the
 *    moment of sending, sent as a hidden field, then shown on the thank-you
 *    note and added to the WhatsApp photo message, so the team can match the
 *    photos to the request; the piece or package the visitor came from
 *    (?piece= / ?package= on the 3D links) travels as "Asked about";
 *  - one custom event pv_fms_submit after a successful send (for the custom
 *    pixel: GA4 fms_submit, Meta Lead), published once per request.
 * After a successful send the thank-you note takes the focus.
 */
(function () {
  var form = document.getElementById('PvPrpContactForm');
  if (!form) return;

  var KEY = 'pvFmsRequest';

  function read() {
    try {
      return JSON.parse(window.sessionStorage.getItem(KEY) || 'null');
    } catch (e) {
      return null;
    }
  }

  function write(value) {
    try {
      if (value === null) window.sessionStorage.removeItem(KEY);
      else window.sessionStorage.setItem(KEY, JSON.stringify(value));
    } catch (e) {
      /* storage blocked: the number still travels in the form */
    }
  }

  function newNumber() {
    var d = new Date();
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var alphabet = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    var tail = '';
    var bytes = new Uint8Array(3);
    if (window.crypto && window.crypto.getRandomValues) window.crypto.getRandomValues(bytes);
    else for (var j = 0; j < 3; j++) bytes[j] = Math.floor(Math.random() * 256);
    for (var i = 0; i < 3; i++) tail += alphabet.charAt(bytes[i] % alphabet.length);
    return 'FMS-' + String(d.getFullYear()).slice(2) + pad(d.getMonth() + 1) + pad(d.getDate()) + '-' + tail;
  }

  var done = form.querySelector('[data-pv-prp-done]');
  if (done) {
    var request = read();
    if (request && request.number) {
      var ref = done.querySelector('[data-pv-prp-ref]');
      if (ref) {
        ref.textContent = (ref.getAttribute('data-label') || 'Request number:') + ' ' + request.number;
        ref.hidden = false;
      }
      var wa = done.querySelector('[data-pv-prp-wa]');
      if (wa) {
        try {
          var url = new URL(wa.getAttribute('href'));
          var text = url.searchParams.get('text') || '';
          url.searchParams.set('text', text + '\n' + (wa.getAttribute('data-wa-ref-label') || 'Request number:') + ' ' + request.number);
          wa.setAttribute('href', url.toString());
        } catch (e) {
          /* keep the plain link */
        }
      }
      if (!request.published) {
        request.published = true;
        write(request);
        if (window.PvSite && typeof window.PvSite.publish === 'function') {
          window.PvSite.publish('pv_fms_submit', {
            request_number: request.number,
            source_code: window.PvSite.sourceCode(),
            room: request.room || '',
            page_path: window.location.pathname
          });
        }
      }
    }
    done.focus();
    done.scrollIntoView({ block: 'center' });
    return;
  }

  var pieces = form.querySelector('[data-pv-prp-pieces]');
  var piecesError = form.querySelector('[data-pv-prp-pieces-error]');
  var emirate = form.querySelector('[data-pv-prp-emirate]');
  var home = form.querySelector('[data-pv-prp-home]');
  var requestField = form.querySelector('[data-pv-prp-request]');
  var contextField = form.querySelector('[data-pv-prp-context]');

  /* The 3D links on piece and package pages pass what the visitor was
     looking at. Only plain text is kept, and only as a hidden field. */
  try {
    var params = new URLSearchParams(window.location.search);
    var asked = params.get('package') ? 'Package: ' + params.get('package') : (params.get('piece') ? 'Piece: ' + params.get('piece') : '');
    if (contextField && asked) contextField.value = asked.replace(/[<>]/g, '').slice(0, 120);
  } catch (e) {
    /* no context */
  }

  function syncHome() {
    if (!emirate || !home) return;
    var option = emirate.options[emirate.selectedIndex];
    var index = option ? parseInt(option.getAttribute('data-index') || '0', 10) : 0;
    var offered = index === 0 || index <= 3;
    home.hidden = !offered;
    if (!offered) {
      var box = home.querySelector('input[type="checkbox"]');
      if (box) box.checked = false;
    }
  }

  if (emirate) {
    emirate.addEventListener('change', syncHome);
    syncHome();
  }

  form.addEventListener('submit', function (event) {
    if (pieces) {
      var ticked = pieces.querySelectorAll('input[type="checkbox"]:checked').length > 0;
      if (piecesError) piecesError.hidden = ticked;
      if (!ticked) {
        event.preventDefault();
        var first = pieces.querySelector('input[type="checkbox"]');
        if (first) first.focus();
        return;
      }
    }
    var existing = read();
    var number = existing && existing.number && !existing.published ? existing.number : newNumber();
    if (requestField) requestField.value = number;
    var room = form.querySelector('input[name="contact[Room]"]:checked');
    write({ number: number, room: room ? room.value : '', published: false });
  });
})();
